export const SET_SELECTED_INSTRUCTOR_ID = 'INSTRUCTORS/SET_SELECTED_INSTRUCTOR_ID';
export const setSelectedInstructorId = ({ instructorId, shouldScrollToItem }) => ({
  type: SET_SELECTED_INSTRUCTOR_ID,
  instructorId,
  shouldScrollToItem,
});

const initialState = {
  selectedInstructorId: null,
  shouldScrollToItem: false,
};

export default (state = initialState, action) => {
  const { type, instructorId, shouldScrollToItem = false } = action;

  switch (type) {
    case SET_SELECTED_INSTRUCTOR_ID:
      return { ...state, selectedInstructorId: instructorId, shouldScrollToItem };
    default:
      return state;
  }
};
